export default {
  login:"登录",
  account:"账号",
  register:"注册",
  loginTime:"登录时间",
  long:"久",
  new:"新",
  content:"内容",
  companyName:"新兴县先丰不锈钢制品有限公司东成分厂",
  email:"邮箱",
  phone:"手机号",
  personalInformation:"个人信息",
  personalSettings:"个人设置",
  password:"密码",
  logout:"退出登录",
  personal_center:"个人中心",
  workshop:"车间",
  personnel:"人事",
  problem:"问题",
  summary:"汇总",
  download:"下载",
  question: {
    problemReport:"6s问题汇报",
    create:"新建问题",
    auditDocuments:"审核单据",
    untreated:"未处理",
    processing:"处理中",
    processed:"已处理",
    pendingReview:"待审核",
    currentMonth:"本月具体问题",
    recently:"最近出现的问题",
    data:"本月数据图",
    specific:"具体问题",
    feedbackContent:"反馈内容",
    issuesWorkshop:"本月车间没有出现问题",
    viewingIssues:"查看问题",
    deductionSituation:"扣分情况",
    specificLocation:"具体位置",
    discoveryTime:"问题发现时间",
    requestRectificationTime:"要求整改时间",
    actualRectificationTime:"实际整改时间",
    processingStatusOfEachWorkshop:"各车间处理情况",
    workshopFeedback:"车间反馈",
    frequency:"问题次数",
    workshopAffiliation:"所属车间",
    sendMessage:"发送消息"
  },
  attendance:{
    value:"考勤",
    dongchengNoProduction:"东成厂-非生产",
    dongchengProduction:"东成厂-生产",
    bakingNoProduction:"烘培-非生产",
    bakingProduction:"烘培-生产",
    personal:'个人考勤',
    number:'考勤号',
    workCard:"上班卡",
    offDutyCard:"下班卡",
    data:"产值校准数据",
    team:"班组",
    wages:"工资",
    punching:"打卡记录",
    punchingNum:"打卡次数",
    overtimeHours:"加班小时",
    worktime:"工时",
    totalWork:"总工时",
    total:"统计",
    recosting:"重计",
    worklate:"迟到分钟",
    extra:"出差工时",
    allDay:"总天数",
    allOvertime:"总加班工时",
    allWorktime:"总工时",
    normalDay:"正常上班天数",
    normalOvertime:"正常加班工时",
    saturdayDay:"周六日上班天数",
    saturdayOvertime:"周六日加班小时",
    holiday:"节假日上班天数",
    holidayOvertime:"节假日上班天数",
    absentee:"缺勤次数",
    clockIn:"打卡",
    adjust:"调整",
    leave:"请假",
    supplementaryWorkingHours:"补工时",
    cardReplacement:"补卡",
    clockInDetails:"打卡明细",
    cardReplacementApplication:"补卡申请",
    workHourApplication:"工时申请",
    checkInAdjustment:"打卡调整",
    leaveVerification:"请假核销",
    check:"核对",
    leaveEarly:"早退",
    beLate:"迟到",
    businessTrip:"出差",
  },
  mealExpenses:"饭餐费",
  project:"项目",

  underDevelopment:"开发中",
  inDesign:"设计中",
  inProgress:"进行中",
  shipped:"已出货",
  graded:"已评分",
  unrated:"未评分",
  total:"合计",
  totalScore:"总分",
  averageScore:"平均分",
  totalDeductionPoints:"总扣分",
  qualified:"合格",
  unqualified:"不合格",
  remarks:"备注",
  class:"分类",
  index:"索引",
  all:"全部",
  creationTime:"创建时间",
  data:"原数据",
  view:"查看",
  add:"新增",
  edit:"编辑",
  query:"查询",
  update:"更新",
  save:"保存",
  delete:"删除",
  batchDelete:"批量删除",
  bind:"绑定",
  cancel:"取消",
  confirmed:"确认",
  success:"成功",
  cannotBeEmpty:"不能为空",
  submit:"提交",
  clear:"清空",
  group:"分组",
  reset:"重置",
  details:"详情",
  export:"导出",
  noData:"无数据",
  import:"导入",
  pass:"通过",
  fail:"不通过",
  refute:"反驳",
  score:"得分",
  upload:"上传",
  img:"照片",
  user:"用户",
  moniker:"姓名",
  main:"主界面",
  name:"名称",
  strategy:"策略",
  select:"选择",
  exit:"退出",
  workType:"工种",
  depart:"部门",
  positions:"职位",
  morning:"上午",
  afternoon:"下午",
  date:"日期",
  wholeYears:"全年",
  years:"年",
  months:"月",
  days:"日",
  daysNum:"天数",
  sameDay:"当天",
  holidays:"节假日",
  dateInterval:"时间区间",
  approval:"审批",
  category:"类别",
  operation:"操作",
  opinion:"意见",
  uploader:"上传人",
  english:"英文",
  chinese:"中文",
  thai:"泰文",
  type:"类型",
  sequence:"顺序",
  menu:{
    viewDetails:"查看详细",
    checkMonthlyCardShortages:"查看每月缺卡",
    checkTheDailyCardShortage:"查看每天缺卡",
    workInquiriesForConsecutiveDays:"连续14天上班查询",
    viewTheListOfMissingCards:"查看缺卡列表",
    continuousWorkingHours:"已连续上班时间",
    personnelMaintenanceStatistics:"人员维修统计",
    equipmentMaintenanceStatistics:"设备维修统计",
    workshopMaintenanceStatistics:"车间维修统计",
    importAttendance:"导入考勤",
    lateQuery:"迟到记录查询",
    absentee:"核销假条",
    lateSchedule:"迟到时间表",
    annualAttendanceStatistics:"全年考勤统计",
    scoresOfEachWorkshop:"月各车间得分情况",
    numberOfProblemsInEachWorkshop:"月各车间问题数量",
    noMessageRecordsAvailableAtTheMoment:"暂无消息记录"
  },
  error:{
    pleaseEnterDate:"请输入日期",
    mes:"发生错误",
    param:"参数错误"
  },
  mes:{
    connectionSuccessful:"连接成功",
    loading:"正在加载",
    disconnect:"断开连接",
    reconnecting:"正在重新连接",
    rconnectionFailed:"重连失败",
    pleaseEnterTheTimeCorrectly:"请正确输入时间",
    pleaseEnterFeedbackContent:"请输入反馈内容",
    pleaseSelect:"请选择",
    pleaseEnterYourPhoneNumber:"请输入手机号码",
    chooseaMachine:"选择机器",
    selectExamPaper:"选择试卷",
    selectParticipants:"选择参加人员",
    pleaseUploadPictures:"请上传图片",
    pleaseSelectAFollowUpPerson:"请选择跟进人",
    pleaseEnterAtLeastWords:"请输入至少20字",
    pleaseEnterTheNameOfTheExamPaper:"请输入试卷名称",
    pleaseEnterTheSuggestedDuration:"请输入建议时长",
    pleaseEnterAHeading:"请输入标题",
    pleaseEnterInOrder:"请输入顺序",
    sentSuccessfully:"发送成功",
    userRefusesToReceiveInformation:"用户拒接收信息",
  },
  finish: "已完成",
  create: "待接单",
  process: "处理中",
  faultReportingTime:"报障时间",
  reporter:"报障人",
  faultContent:"报障内容",
  singlePersonReception:"接单人",
  state:"状态",
  jan:"1月",
  feb:"2月",
  mar:"3月",
  apr:"4月",
  may:"5月",
  jun:"6月",
  jul:"7月",
  aug:"8月",
  sep:"9月",
  oct:"10月",
  nov:"11月",
  dec:"12月",
  number:"号",
  device:{
    name:"设备",
    repairQuantity:"维修数量"
  },
  accessory:"配件",
  stamping:"冲压",
  braze:"钎焊",
  freeze:"烧焊",
  burnishing:"抛大",
  sanding:"砂光",
  accessoriesPolishing:"抛配",
  package:"包装",
  mold:"模具",
  engineering:"工程部",
  warehouse:"仓库",
  production:"生产科",
  technology:"技术科",
  inspection:"质检科",
  equipment:"设备科",
  finance:"财务科",
  manage:"企管科",
  office:"办公室",
  grade:"得分",
  inProgress:"跟进中",
  followUpCompleted:"跟进完成",
  verificationCompleted:"验证完成",
  verificationFailed:"验证不通过",
  verifiedAsQualified:"验证合格",
  verificationIsNotQualified:"验证不合格",
  inThePlan:"计划中",
  started:"已开始",
  settled:"已结算",
  option:"选项",
  fillInTheBlank:"填空",
  examine:{
    view:"考核",
    content:"考核内容",
    standard:"考评标准",
    poor:"差（60以下）",
    secondary:"中（61-75）",
    good:"良（76-90）",
    outstanding:"优（91-100）",
    assessor:"考核人",
    evaluatedPerson:"被评人",
    assessmentMonth:"考核月份",
    contentAndDefinition:"指标具体内容及定义",
    manageGrade:"分管评分",
    metrics:"细分指标",
    weight:"分值",
    superMax:"超过项目最大分",
    total:{
      depart:"部门统计",
      workshop:"车间统计"
    },
    depart:{
      personInChargeRating:"部门负责人评分",
      ratingForm:"年度东成分厂部门月度绩效评分表",
      evaluatedDepartment:"被考评部门",
      rating:"部门评分",
      instructions:"说明：本表格适用于对科室人员的绩效考核。其考核指标、权重及具体释义非常明确、详细，便于实际操作与应用。使用过程中，可根据不同岗位特征、业务特性，适当调整考核指标内容及其权重。科长考核得分取本部门所有人员的平均分。"
    },
    device:{
      content:"保养内容",
      ratingForm:"东成厂各车间设备日常保养评分",
      instructions:"备注：每项内容视问题严重可酌情扣分"
    },
    logistics:{
      ratingForm:"东成厂精益生产后勤部门考核评分表",
      instructions:`说明：1、各人对部门评分要公平、公正，不能因个人矛盾影响到评分的公正性。
      2、评分后将该评估表交到企管科进行汇总。
      3、工程部、模具车间、仓库评分标准：厂部评分占40%，车间评分占60%，最终得分去各评分人所评分值的平均分。`
    },
    satisfaction:{
      ratingDepartment:"评分部门",
      ratingWorkshop:"评分车间",
      departRatingForm:"部门满意度评分表",
      workshopRatingForm :"车间满意度评分表",
      instructions:"备注：每项内容视问题严重可酌情扣分"
    },
    warehouse:{
      ingredients:"注：请公平公正对有业务接触仓管员服务态度评分，无业务接触的不评。"
    },
    workshop:{
      ratingForm:"年度东成分厂车间月度绩效评分表",
      ratingWorkshop:"考核车间",
      explain:"加扣分说明",
      instructions:"各负责人每月5日前将数据交企管科梁心怡处",
      assessment_dimension:"考核维度",
      target_name:"指标名称",
      source:"数据来源",
      assessment_score:"考核分",
    }
  },
  training:{
    lecturer:"讲师",
    name:"培训名",
    numberOfRetakes:"重考次数",
    startSigningIn:"开始签到",
    endOfTraining:"结束培训",
    againTraining:"重新培训",
    notSignedIn:"未签到",
    signedIn:"签到",
    difficulty:"难度",
    rating:"评分",
    exam:"考试",
    paperEditor:"试卷编辑器",
    title:"题目",
    type:"题型",
    paper:"试卷",
    answer:"答案",
    parse:"解析",
    actualNumberOfParticipants:"实参加人数",
    realNumber:"应参加培训人数",
    attendanceRate:"出勤率",
    machine:"机器",
    date:"培训日期",
    plan:"计划",
    checkInQRCode:"签到二维码",
    dragMe:"拖动我",
    remarks:"（注: 内部使用，试卷分单选题、判断题，共100分，90分合格）",
    compilerAdds:"编译器添加",
    downloadTheExamPaper:"下载试卷",
    questionnaireEditor:"问卷编辑器",
    pasteQuestionnaireText:"粘贴问卷文本",
    question:"题干",
    questionType:"题型",
    correctAnswer:"正确答案",
    questionScore:"题目分数",
    fillInTheTestPaperInformation:"填写试卷信息",
    duration:"时长",
    multiple_choice:"单选",
    single_choice:"多选",
    true_false:"判断",
    pasteFill:"粘贴填充",
    richTextEditing:"富文本编辑",
    suggestedDuration:"建议时长（分钟）",
    heading:"标题"
  },
  verification:{
    quality:"质量",
    specis:"规格名称",
    trackingNumber:"单号",
    description:"质量问题描述",
    productionQuantity:"生产数/抽样数",
    nonconformingCount:"不良数/率",
    follower:"跟进人",
    responsibleDepartment:"责任部门",
    responsiblePerson:"责任人",
    creator:"创建人",
    formFiller:"填表人",
    rootCauseAnalysis:"原因分析",
    rectificationMeasures:"整改措施",
    completionTimeOfRectification:"整改完成时间",
    validator:"验证人",
    verificationCompletionTime:"验证完成时间",
    verificationResult:"验证结果",
    requestRectificationTime:"要求整改时间",
    actualRectificationTime:"实际整改时间"
  },
  hostel:{
    code:"宿舍编号",
    facility:"设施",
    // 退租
    // 宿舍信息
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js